import { createContext } from "react";

export const TagListContext = createContext([]);
